import { CategoryIcons } from '@/components/icons/CategoryIcons';
import { useCategories } from '@/services/api/hooks/catalog';
import { ProductsList } from './ProductsList';
import { SpecFilterGroup, useCategoryGroupedProducts } from './useFilteredProducts';
import { RoleType } from '@/services/authentication/hooks/user';
import { useCatalogueService } from '@/services/catalogue/useCatalogueService';

export const AllProducts = ({
  searchQuery,
  specFilter,
  filterProductIds,
  manufacturerFilter,
  carouselMode
}: {
  searchQuery?: string;
  specFilter?: SpecFilterGroup[];
  filterProductIds?: string[];
  manufacturerFilter?: string[];
  carouselMode?: boolean;
}) => {
  const role = useCatalogueService(s => s.configuration.for);
  const isAdmin = role === RoleType.Admin;
  
  const groupedProducts = useCategoryGroupedProducts({ searchQuery, specFilter, filterProductIds, manufacturerFilter, applyRegionFilter: isAdmin });

  const [categories] = useCategories();
  const getCategoryDescriptionFromName = (categoryName: string) => {
    return categories.find(category => category.name === categoryName)!.description;
  };

  return (
    <div className="flex flex-col px-6 space-y-5">
      {Object.keys(groupedProducts).length > 0 ? (
        Object.entries(groupedProducts).map(([categoryName, products]) => (
          <div className="flex flex-col space-y-3" key={categoryName}>
            <div className="flex items-center font-semibold space-x-1">
              <span className="text-4xl">{CategoryIcons[getCategoryDescriptionFromName(categoryName)]}</span>
              <span className="text-3xl">{categoryName}</span>
            </div>
            <ProductsList products={products} carouselMode={carouselMode} />
          </div>
        ))
      ) : (
        <p className="font-semibold">
          {searchQuery || specFilter
            ? 'No products match the current search filter.'
            : filterProductIds && filterProductIds.length === 0
            ? 'No products have been selected'
            : 'No products have been uploaded to the system.'}
        </p>
      )}
    </div>
  );
};
